import http from 'plugins/axios'

export default {
  //更新后的查询所有用户持仓信息
  getUserList(params) {
    return http.get({
      url: `/ta/admin/channel/position/list`,
      params,
    })
  },
  //获取交易对列表
  getSymbolList() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',data:{type:'CONTRACT'},
    })
  },
  // 添加备注
  addRemark({ channelId, userId, remarks }) {
    return http.post({
      url: `/channel/user/addRemark?channelId=${channelId}&remarks=${remarks}&userId=${userId}`,
    })
  },

  //法币资产明细
  getDetail({ userId, page, size, startTime, endTime }) {
    return http.get({
      url: `/channel/otc/detail?userId=${userId}&page=${page}&size=${size}&startTime=${startTime}&endTime=${endTime}`,
    })
  },
  //获取币种列表
  getCoinList() {
    return http.get({
      url: '/channel/common/coinList',
    })
  },
  //返佣统计记录
  getDetailRecord({ time, channelId }) {
    return http.get({
      url: `/channel/rebate/info?channelId=${channelId}&time=${time}`,
    })
  },
  //汇总字段
  getTotalInfo(params) {
    return http.get({
      url: `/ta/admin/channel/position/totalInfo`,
      params,
    })
  },

  fixClosePosition(data) {
    return http.post({
      url: `/api/thanos-admin/v1/admin/manage/fix-close-position`,
      data,
    })
  },

  getPosition(data) {
    return http.post({
      url: `/api/thanos-admin/v1/admin/manage/get-position`,
      data,
      dataType: 'form'
    })
  },

  takeOverPosition(data) {
    return http.post({
      url: `/api/thanos-admin/v1/admin/manage/take-over-position`,
      data,
    })
  },

}
